export const ContentCheckInsQueryKeys = {
  TrackingSnapshot: 'trackingSnapshot',
}
